module.exports = __webpack_public_path__ + "static/media/JioLoader.85b02e13.svg";